import QueryString from 'qs';

const paramsSerializer = (params) => {
    return QueryString.stringify(params, { arrayFormat: "repeat" });
};

export { paramsSerializer };
